import { render } from "./CCS-splc.vue?vue&type=template&id=3dc40770&scoped=true"
import script from "./CCS-splc.vue?vue&type=script&lang=js"
export * from "./CCS-splc.vue?vue&type=script&lang=js"

import "./CCS-splc.vue?vue&type=style&index=0&id=3dc40770&scoped=true&lang=css"

import exportComponent from "F:\\MyProject\\8.142.129.201\\FCS\\admin\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc40770"]])

export default __exports__